import type { ReactNode } from "react"

// Profile picture mapping for consistent avatars
export const profilePictures: Record<string, string> = {
  CowboysFan99: "https://a.bracky.app/assets/landing/avatars/bracky-cowboysfan99.webp",
  LakersLegacy23: "https://a.bracky.app/assets/landing/avatars/bracky-lakerslegacy23-1.webp",
  BruinsCup88: "https://a.bracky.app/assets/landing/avatars/bracky-hockygrind88.webp",
  MaddenKing1: "https://a.bracky.app/assets/landing/avatars/bracky-soonerbro-2.webp",
  "0kPicklePro": "https://a.bracky.app/assets/landing/avatars/bracky-okpicklepro-2.webp",
  CinemaFanatic: "https://a.bracky.app/assets/landing/avatars/bracky-cinemafanatic-2.webp",
}

// Helper function to highlight @mentions and $BRACKY in text
export function highlightMentions(text: string): ReactNode[] {
  // Split the string into parts that are either @mentions, $BRACKY (case-insensitive), or plain text
  const parts = text.split(/(@\w+|\$BRACKY\b)/gi)

  return parts.map((part) => {
    if (part.startsWith("@")) {
      // Highlight @mentions
      return (
        <span key={`mention-${part}`} className="text-[#30DFFF] font-medium">
          {part}
        </span>
      )
    }

    if (part.toUpperCase() === "$BRACKY") {
      // Highlight the $BRACKY token anywhere it appears
      return (
        <span key="token-bracky" className="text-[#30DFFF] font-medium">
          {part}
        </span>
      )
    }

    return part
  })
}
